export default "__VITE_ASSET__1e828271__"